
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowDown, Star } from "lucide-react";

const CleanHeroSection = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('refund-form-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-20 pb-8 bg-gradient-to-b from-transparent via-white/10 to-white/20">
      <div className="container px-4">
        <div className="max-w-2xl mx-auto text-center">
          {/* Main heading */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
            Get Refunds in Minutes 
            <span className="block text-primary">Powered by AI</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
            Fast, context-aware refund and flight claim letters with 0% commission.
          </p>

          {/* CTA Button */}
          <Button 
            onClick={scrollToForm}
            size="lg"
            className="h-12 px-8 text-base font-medium"
          >
            Start Your Refund Request
            <ArrowDown className="w-4 h-4 ml-2" />
          </Button>

          {/* Quick stats */}
          <div className="mt-8 grid grid-cols-3 gap-4 max-w-lg mx-auto">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">2.3k+</div>
              <div className="text-xs text-muted-foreground">Requests</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">$847K</div>
              <div className="text-xs text-muted-foreground">Recovered</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary flex items-center justify-center">
                4.4<Star className="h-5 w-5 fill-current text-primary ml-0.5" />
              </div>
              <div className="text-xs text-muted-foreground">Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CleanHeroSection;
